// ---------------------------------------------------------------------------------

// 正常下载
const MYPRO_APPSDOWN = resolve => require(['../components/views/appsdown'], resolve);
// 绑定授权
const MYPRO_BINDDOWN = resolve => require(['../components/views/binddown'], resolve);
// 扫码绑定
const MYPRO_AUTHBIND = resolve => require(['../components/views/scanbind'], resolve);

const MYPRO_EXTDOWN = resolve => require(['../components/views/tg-bind'], resolve);
const MYPRO_CHANNEL = resolve => require(['../components/views/tg-data'], resolve);


const funcs = [
  {
    path: '/appdown/:dtype?/:sid?/:duid?',
    name: 'MYPRO-APPSDOWN',
    component: MYPRO_APPSDOWN,
    meta: { title: "开心渔场 - 应用下载", enable: true, requiresAuth: false, navigate: false }
  },
  {
    path: '/authdown/:store/:uuid',
    name: 'MYPRO-BINDDOWN',
    component: MYPRO_BINDDOWN,
    meta: { title: "开心渔场 - 授权下载", enable: true, requiresAuth: false, navigate: false }
  },
  {
    path: '/scbind/:store/:uuid?',
    name: 'MYPRO-AUTHBIND',
    component: MYPRO_AUTHBIND,
    meta: { title: "开心渔场 - 扫码绑定", enable: true, requiresAuth: false, navigate: false }
  },
  {
    path: '/extdata/:cuid?',
    name: 'MYPRO-CHANNEL',
    component: MYPRO_CHANNEL,
    meta: { title: "开心渔场 - 推广数据", enable: true, requiresAuth: false, navigate: false }
  },
  {
    path: '/extdown/:type?/:uuid?/:sign?',
    name: 'MYPRO-EXTDOWN',
    component: MYPRO_EXTDOWN,
    meta: { title: "开心渔场 - 推广下载", enable: true, requiresAuth: false, navigate: false }
  },
  // 一定要在最后
  {
    path: '*',
    component: 404,
    meta: { requiresAuth: true }
  }
];

export default funcs;



// WEBPACK FOOTER //
// ./src/vuex/navbar.js